export enum UserTypeTabEnum {
  INTERNAL_USER = "INTERNAL_USER",
  EXTERNAL_USER = "EXTERNAL_USER"
}
